/* eslint-disable */
import { store } from "@/store";
import ReconnectingWebSocket from 'reconnecting-websocket';
import {wsMessageHandler} from "@/socket/wsMessageHandler";
let socket;
let pingInterval;
let pongTimeout;

export const ws = () => {
  /*Подключаемся к Websockets*/
  let wsurl = `wss://staging.ws.skyservice.online/${store.accountId}/${store.accountId}/${store.token}/`;

  try {
    console.log("ws connect to", wsurl);

    //socket = new WebSocket(wsurl);
    try {
      socket = new ReconnectingWebSocket(wsurl, [], {
        automaticOpen: true,
        reconnectInterval: 3000, // спроба реконекту кожні 3 секунди
        maxReconnectInterval: 10000, // максимальний інтервал 10 секунд
        reconnectDecay: 1.5,
        timeoutInterval: 2000,
        maxReconnectAttempts: null // безкінечні спроби реконекту
      });
      //socket = new WebSocket(wsurl);
    } catch (err) {
      //  console.log(err)
    }
    store.socket = socket;

    socket.onopen = (event) => {
      console.log("connected");

      store.wsConnection = true;
      
      // Запускаємо heartbeat механізм
      startHeartbeat();
    }

    socket.onclose = (event) => {
      // console.log("WebSocket was closed now");
      // console.log(event.code);
      // console.log(event.reason);
      store.wsConnection = false;
      stopHeartbeat();
      // setTimeout(ws, 4000);
    };

    socket.onerror = (event) => {
      // console.log("WebSocket error");
      // console.log(event);
      // console.log(event.reason);
      store.wsConnection = false;
      stopHeartbeat();
    }

    socket.onmessage = (event) => {
      //console.log("ws event:", event);
      let message = JSON.parse(event.data);
      
      // Скидаємо таймер pong при отриманні будь-якого повідомлення
      if (pongTimeout) {
        clearTimeout(pongTimeout);
        pongTimeout = null;
      }
      
      // Обробка pong відповіді
      if (message.type === 'pong') {
        console.log('Pong received:', message.timestamp);
        return;
      }
      
      //console.log("ws message", message)
      wsMessageHandler(message);
    };

    window.onbeforeunload = () => {
      stopHeartbeat();
      socket.close();
    }

  } catch (err) {
    console.error(err);
  }
}

// Функція для запуску heartbeat
function startHeartbeat() {
  // Очищаємо попередні інтервали, якщо вони є
  stopHeartbeat();
  
  // Відправляємо ping кожні 15 секунд
  pingInterval = setInterval(() => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      const pingMessage = {
        type: "ping",
        timestamp: new Date().toISOString()
      };
      
      console.log('Sending ping:', pingMessage.timestamp);
      socket.send(JSON.stringify(pingMessage));
      
      // Встановлюємо таймер для очікування pong (5 секунд)
      pongTimeout = setTimeout(() => {
        console.log('No pong received, connection might be lost. Reconnecting...');
        // Якщо не отримали pong, закриваємо з'єднання для реконекту
        if (socket) {
          socket.close(); // ReconnectingWebSocket автоматично перепідключиться
          // Додатково можна форсувати реконект
          socket.reconnect();
        }
      }, 5000);
    }
  }, 15000); // Кожні 15 секунд
}

// Функція для зупинки heartbeat
function stopHeartbeat() {
  if (pingInterval) {
    clearInterval(pingInterval);
    pingInterval = null;
  }
  if (pongTimeout) {
    clearTimeout(pongTimeout);
    pongTimeout = null;
  }
}

export default socket;